/**
 * @generated SignedSource<<b5b48afb644b1c9ba2115e786ebc4620>>
 * @relayHash b0ec5645a9816290c20ca3f2be3c63ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b19a28811756f63c5661a06a4b602a408a80b7c8bf0a7bb74fe1ca80eb1c203e

import type { ConcreteRequest } from 'relay-runtime';
export type FolderRedirectFirstChildQuery$variables = {
  id: string;
};
export type FolderRedirectFirstChildQuery$data = {
  readonly ptpage: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
    } | null;
    readonly id: string;
    readonly title: string | null;
  } | null;
};
export type FolderRedirectFirstChildQuery = {
  response: FolderRedirectFirstChildQuery$data;
  variables: FolderRedirectFirstChildQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "CURRENT",
          "DRAFT"
        ]
      }
    ],
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "ptpage",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          }
        ],
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "children",
        "plural": false,
        "selections": [
          {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "type"
              },
              {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "webui"
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": "children(first:1)"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FolderRedirectFirstChildQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FolderRedirectFirstChildQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "b0ec5645a9816290c20ca3f2be3c63ff",
    "id": "b19a28811756f63c5661a06a4b602a408a80b7c8bf0a7bb74fe1ca80eb1c203e",
    "metadata": {},
    "name": "FolderRedirectFirstChildQuery",
    "operationKind": "query",
    "text": "query FolderRedirectFirstChildQuery($id:ID!){ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,children(first:1){nodes{id,title,type,links{webui}}}}}"
  }
};
})();

(node as any).hash = "fe1ad2671600d4e91a1ebc56f4fdea48";

export default node;
